import { createSelector } from '@reduxjs/toolkit';
import { getProfile } from './getProfile';

export const getProfileID = createSelector(getProfile, (profile) => profile?.id);
